export const reorderDemoLicenses = (licenses: any, orderedDemoLicensesIds: any) => {
  licenses.sort((a: any, b: any) => orderedDemoLicensesIds.indexOf(a.productId) - orderedDemoLicensesIds.indexOf(b.productId))
};